module.exports = __webpack_public_path__ + "static/media/S4N2-1.71d9c9e6.svg";